import React, { Component } from 'react';
import { observer, inject } from "mobx-react";
import { withRouter, NavLink } from "react-router-dom";
import Header from './Header';
let store = null;
var self = null;
@inject("appStore")
@observer
class Portfolio extends React.Component {

    constructor(props) {
        super(props);
    }


    render() {
        return (
            <section class="o-section  t-section  ">

                <div class="o-section__header-bg  t-section__header"></div>
                <div class="o-section__content-bg  t-section__content"></div>

                <div class="o-container">
                    <div class="o-section__container">

                        <header class="o-section__header  t-section__header">
                            <div class="o-content">
                                <h2 class="o-section__heading">
                                    Skills
                                </h2>
                                <div class="o-content__body  o-section__description">
                                    <span style={{fontWeight:'bold'}}>Core Focus:</span> Cloud-native GenAI platforms, agentic AI systems, and enterprise automation at scale.
                                </div>
                            </div>
                        </header>

                        <div class="o-section__content  t-section__content  ">

                            <div class="o-grid">

                                <div class="o-grid__col-sm-6">
                                    <div class="o-content">
                                        <div class="o-media  o-media--block">
                                            <div class="o-media__figure">
                                                <div class="c-number  t-primary-color">
                                                    {/* 100<small>%</small> */}
                                                </div>
                                            </div>
                                            <div class="o-media__body">
                                                <h3>Cloud Architecture & Platform Engineering</h3>
                                            </div>
                                        </div>
                                        <div class="c-progress-bar  o-content__body  t-border-color-bg  u-mt-text">
                                            <div class="a-progress-bar  c-progress-bar__filler  t-primary-bg" data-percent="100"></div>
                                        </div>
                                        <ul>
                                            <li>
                                            AWS Landing Zone design & multi-account governance
                                            </li>
                                            <li>
                                            AWS Organizations, SCPs & account provisioning automation
                                            </li>
                                            <li>
                                            Serverless architecture & event-driven systems
                                            </li>
                                            <li>
                                            Multi-cloud platforms (AWS, GCP, Azure)
                                            </li>
                                            <li>
                                            Cloud cost analysis, billing optimization & security posture reviews
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="o-grid__col-sm-6">
                                    <div class="o-content">
                                        <div class="o-media  o-media--block">
                                            <div class="o-media__figure">
                                                <div class="c-number  t-primary-color">
                                                    {/* 50<small>%</small> */}
                                                </div>
                                            </div>
                                            <div class="o-media__body">
                                                <h3>Generative AI based Development & LLM Engineering</h3>
                                            </div>
                                        </div>
                                        <div class="c-progress-bar  o-content__body  t-border-color-bg  u-mt-text">
                                            <div class="a-progress-bar  c-progress-bar__filler  t-primary-bg" data-percent="100"></div>
                                        </div>
                                        <ul>
                                            <li>
                                                Large Language Model (LLM) application design
                                            </li>
                                            <li>
                                                Retrieval-Augmented Generation (RAG) & GraphRAG systems
                                            </li>
                                            <li>
                                                Prompt engineering & structured outputs
                                            </li>
                                            <li>
                                                Tool-calling & function-driven LLM workflows
                                            </li>
                                            <li>
                                                Provider-agnostic AI architecture (Bedrock, OpenAI, OSS models)
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="o-grid__col-sm-6">
                                    <div class="o-content">
                                        <div class="o-media  o-media--block">
                                            <div class="o-media__figure">
                                                <div class="c-number  t-primary-color">
                                                    {/* 70<small>%</small> */}
                                                </div>
                                            </div>
                                            <div class="o-media__body">
                                                <h3>Agentic AI Systems & Orchestration</h3>
                                            </div>
                                        </div>
                                        <div class="c-progress-bar  o-content__body  t-border-color-bg  u-mt-text">
                                            <div class="a-progress-bar  c-progress-bar__filler  t-primary-bg" data-percent="100"></div>
                                        </div>
                                        <ul>
                                            <li>
                                                Agentic AI workflows using LangGraph
                                            </li>
                                            <li>
                                                Multi-agent architectures (planner, executor, reviewer patterns)
                                            </li>
                                            <li>
                                                LangChain, LlamaIndex & CrewAI
                                            </li>
                                            <li>
                                                Custom MCP (Model Context Protocol) servers
                                            </li>
                                            <li>
                                                Autonomous task execution & AI tool routing
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="o-grid__col-sm-6">
                                    <div class="o-content">
                                        <div class="o-media  o-media--block">
                                            <div class="o-media__figure">
                                                <div class="c-number  t-primary-color">
                                                    {/* 75<small>%</small> */}
                                                </div>
                                            </div>
                                            <div class="o-media__body">
                                                <h3>Conversational AI, NLP, NLU & NLG</h3>
                                            </div>
                                        </div>
                                        <div class="c-progress-bar  o-content__body  t-border-color-bg  u-mt-text">
                                            <div class="a-progress-bar  c-progress-bar__filler  t-primary-bg" data-percent="100"></div>
                                        </div>
                                        <ul>
                                            <li>
                                               Contextual & multi-turn chatbot design
                                            </li>
                                            <li>
                                                Dialogflow, Rasa, AWS Lex & Bedrock-based bots
                                            </li>
                                            <li>
                                                NLP pipelines (classification, summarization, QA)
                                            </li>
                                            <li>
                                                Aspect-based sentiment analysis
                                            </li>
                                            <li>
                                                Enterprise knowledge chatbots over Confluence
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="o-grid__col-sm-6">
                                    <div class="o-content">
                                        <div class="o-media  o-media--block">
                                            <div class="o-media__figure">
                                                <div class="c-number  t-primary-color">
                                                    {/* 80<small>%</small> */}
                                                </div>
                                            </div>
                                            <div class="o-media__body">
                                                <h3>Cloud-Native AI Platforms & Model Ops</h3>
                                            </div>
                                        </div>
                                        <div class="c-progress-bar  o-content__body  t-border-color-bg  u-mt-text">
                                            <div class="a-progress-bar  c-progress-bar__filler  t-primary-bg" data-percent="100"></div>
                                        </div>
                                        <ul>
                                            <li>
                                                AWS Bedrock & OpenAI integrations
                                            </li>
                                            <li>
                                                HuggingFace, Ollama & quantized models
                                            </li>
                                            <li>
                                                Serverless AI backends & inference pipelines
                                            </li>
                                            <li>
                                                Bedrock ↔ OpenAI proxy design
                                            </li>
                                            <li>
                                                AI cost, latency & performance optimization
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="o-grid__col-sm-6">
                                    <div class="o-content">
                                        <div class="o-media  o-media--block">
                                            <div class="o-media__figure">
                                                <div class="c-number  t-primary-color">
                                                    {/* 70<small>%</small> */}
                                                </div>
                                            </div>
                                            <div class="o-media__body">
                                                <h3>Backend & Serverless Engineering</h3>
                                            </div>
                                        </div>
                                        <div class="c-progress-bar  o-content__body  t-border-color-bg  u-mt-text">
                                            <div class="a-progress-bar  c-progress-bar__filler  t-primary-bg" data-percent="100"></div>
                                        </div>
                                        <ul>
                                            <li>
                                                AWS Lambda, Step Functions, SQS, SNS, SES
                                            </li>
                                            <li>
                                                Event-driven & microservices architecture
                                            </li>
                                            <li>
                                                REST API design & integration
                                            </li>
                                            <li>
                                                Python (FastAPI, Flask, Boto3)
                                            </li>
                                            <li>
                                                Node.js backend systems
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="o-grid__col-sm-6">
                                    <div class="o-content">
                                        <div class="o-media  o-media--block">
                                            <div class="o-media__figure">
                                                <div class="c-number  t-primary-color">
                                                    {/* 65<small>%</small> */}
                                                </div>
                                            </div>
                                            <div class="o-media__body">
                                                <h3>Frontend & Full-Stack Development</h3>
                                            </div>
                                        </div>
                                        <div class="c-progress-bar  o-content__body  t-border-color-bg  u-mt-text">
                                            <div class="a-progress-bar  c-progress-bar__filler  t-primary-bg" data-percent="100"></div>
                                        </div>
                                        <ul>
                                            <li>
                                                React.js, HTML5, CSS3 & JavaScript
                                            </li>
                                            <li>
                                                API-driven frontend architecture
                                            </li>
                                            <li>
                                                Real-time applications (WebSockets, Socket.io)
                                            </li>
                                            <li>
                                                AWS Amplify deployments
                                            </li>
                                            <li>
                                                Admin dashboards & internal tooling
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="o-grid__col-sm-6">
                                    <div class="o-content">
                                        <div class="o-media  o-media--block">
                                            <div class="o-media__figure">
                                                <div class="c-number  t-primary-color">
                                                    {/* 80<small>%</small> */}
                                                </div>
                                            </div>
                                            <div class="o-media__body">
                                                <h3>DevOps, Infra as Code & Automation</h3>
                                            </div>
                                        </div>
                                        <div class="c-progress-bar  o-content__body  t-border-color-bg  u-mt-text">
                                            <div class="a-progress-bar  c-progress-bar__filler  t-primary-bg" data-percent="100"></div>
                                        </div>
                                        <ul>
                                            <li>
                                                Infrastructure as Code (AWS CDK – Python & Node.js)
                                            </li>
                                            <li>
                                                CI/CD pipelines (GitHub, Bitbucket, CodePipeline, CodeBuild)
                                            </li>
                                            <li>
                                                Automated deployments & environment isolation
                                            </li>
                                            <li>
                                                Monitoring, logging & observability
                                            </li>
                                            <li>
                                                Cloud automation & developer productivity tooling
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="o-grid__col-sm-6">
                                    <div class="o-content">
                                        <div class="o-media  o-media--block">
                                            <div class="o-media__figure">
                                                <div class="c-number  t-primary-color">
                                                    {/* 80<small>%</small> */}
                                                </div>
                                            </div>
                                            <div class="o-media__body">
                                                <h3>Data, Knowledge & Storage Systems</h3>
                                            </div>
                                        </div>
                                        <div class="c-progress-bar  o-content__body  t-border-color-bg  u-mt-text">
                                            <div class="a-progress-bar  c-progress-bar__filler  t-primary-bg" data-percent="80"></div>
                                        </div>
                                        <ul>
                                            <li>
                                                DynamoDB, Aurora Serverless, PostgreSQL, MongoDB
                                            </li>
                                            <li>
                                                Vector databases for RAG systems
                                            </li>
                                            <li>
                                                AWS S3 & GCP Buckets
                                            </li>
                                            <li>
                                                Knowledge graphs & document stores
                                            </li>
                                            <li>
                                                Data modeling & query optimization
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="o-grid__col-sm-6">
                                    <div class="o-content">
                                        <div class="o-media  o-media--block">
                                            <div class="o-media__figure">
                                                <div class="c-number  t-primary-color">
                                                    {/* 80<small>%</small> */}
                                                </div>
                                            </div>
                                            <div class="o-media__body">
                                                <h3>Security, Governance & Compliance</h3>
                                            </div>
                                        </div>
                                        <div class="c-progress-bar  o-content__body  t-border-color-bg  u-mt-text">
                                            <div class="a-progress-bar  c-progress-bar__filler  t-primary-bg" data-percent="100"></div>
                                        </div>
                                        <ul>
                                            <li>
                                                Cloud governance & policy enforcement
                                            </li>
                                            <li>
                                               Secure AI access & authorization models
                                            </li>
                                            <li>
                                                IAM, authentication & role-based access control
                                            </li>
                                            <li>
                                               Enterprise guardrails for cost & security
                                            </li>
                                            <li>
                                                Compliance-aware cloud & AI architectures
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>
                </div>

            </section>

        );
    }
}
export default withRouter(Portfolio);